import React from "react";

import { getStrukturaMeKategori } from "./data";
import Spinner from "../../containers/Spinner";
import "../../styles/features/structures/CompoundStructure.css";
import Collapse from "./Collapse";
class Strukture extends React.Component {
  dostuff = async () => {
    let response = await getStrukturaMeKategori();
    this.setState({ strukturat: response, finished: true });
  };
  state = {};
  componentWillMount = () => {
    //this.dostuff();
  };
  componentDidMount = () => {
    this.dostuff();
  };
  componentWillReceiveProps() {
    this.dostuff();
  }
  render() {
    console.log(this.state);
    if (!this.state.finished) {
      return <Spinner />;
    }
    return (
      <div style={{ margin: 0 }}>
        {this.state.strukturat && (
          <Collapse
            history={this.props.history}
            data={this.state.strukturat.length > 0 ? this.state.strukturat : []}
          />
        )}
      </div>
    );
  }
}

export default Strukture;
